import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.dashboard`;

export const INIT = `${SCOPE}/INIT`;
export const GET_DASHBOARD = `${SCOPE}/GET_DASHBOARD`;
export const SETUP_TIMELINE = `${SCOPE}/SETUP_TIMELINE`;
